class ProductMeta {
    constructor (theme, elem) {
        this.name = this.constructor.name
        this._theme = theme
        this._elem = elem
    }
    onInit () {
        const tabs = this._elem.querySelectorAll('input[name="product-tab"]')
        if (tabs.length > 0) {
            tabs.forEach((tab) => {
                tab.addEventListener('change', (e) => {
                    if (e.currentTarget.checked) {
                        this.changeTab(e.currentTarget.id)
                    }
                })
            })
        }
    }
    changeTab (id) {
        const content = this._elem.querySelectorAll('[data-product-meta-tabs-content]')
        if (content.length > 0) {
            content.forEach((meta) => {
                meta.classList.remove('product-page__meta__content__item--active')
                if (id === meta.dataset.tab) {
                    meta.classList.add('product-page__meta__content__item--active')
                }
            })
        }
    }
}

export default ProductMeta



// WEBPACK FOOTER //
// ./src/resources/scripts/components/ProductMeta.js